import { useMutation } from '@apollo/client';
import { faEyeSlash } from '@fortawesome/pro-solid-svg-icons';
import gql from 'graphql-tag';
import { withTranslation } from 'react-i18next';

import { refreshCurrentUser } from '../../../common/currentUser';
import ActivityFeed from '../../../components/Atoms/ActivityFeed';
import Button from '../../../components/Atoms/Button';
import ButtonsContainer from '../../../components/Atoms/ButtonsContainer';
import Card from '../../../components/Atoms/Card';

import ReadAllNotificationsMutation from './ReadAllNotificationsMutation.graphql';

const FeedView = ({ readAllButton = false, t, onReadAll = () => {}, ...props  }) => {
  const [readAllNotificationsMutation, { loading: readAllNotificationsMutationLoading }] = useMutation(gql(ReadAllNotificationsMutation));

  const handleReadAll = async () => {
    await readAllNotificationsMutation();
    refreshCurrentUser(true);
    onReadAll();
  };

  return (
    <>
      {readAllButton && (
        <Card transparent>
          <ButtonsContainer position="RIGHT">
            <Button loading={readAllNotificationsMutationLoading} icon={faEyeSlash} theme="SECONDARY" label={t('Mark as read')} action={handleReadAll} />
          </ButtonsContainer>
        </Card>
      )}
      <ActivityFeed {...props} actionFunction={(id) => `/notifications/${id}/`} />
    </>
  );
};

export default withTranslation()(FeedView);
